import classnames from "classnames";
import React, { Component } from "react";

import { TabProps } from "./Tab";
import { TabBadge } from "./TabBadge";

import buttons from "styles/buttons.scss";
import lists from "styles/lists.scss";
import style from "./styles/style.scss";

export interface TabsProps {
    index?: number;
    children?: React.ReactElement<TabProps> | React.ReactElement<TabProps>[];
    rightJustfied?: boolean;
    title?: string;
}
interface TabsState {
    index: number;
    children: React.ReactElement<TabProps>[];
}

export class Tabs extends Component<TabsProps, TabsState> {
    constructor(props: TabsProps) {
        super(props);

        this.state = {
            children: this.getChildrenArray(props.children),
            index: 0,
        };
    }

    componentWillReceiveProps(newProps: TabsProps) {
        this.setState({
            children: this.getChildrenArray(newProps.children),
            index: newProps.index || this.state.index
        });
    }

    getChildrenArray(children: React.ReactElement<TabProps> | React.ReactElement<TabProps>[]): React.ReactElement<TabProps>[] {
        if (children === undefined) {
            return undefined;
        }

        if (!Array.isArray(children)) {
            return [children];
        } else {
            return children;
        }
    }

    handleButtonClick(index: number) {
        this.setState({ index });
    }

    render() {
        const headerClassName = this.props.rightJustfied ? style.rightTabsHeader : style.tabsHeader;

        return (
            <div className={style.tabWrap}>
                <header className={headerClassName}>
                    {this.renderTitle(this.props.title)}

                    <nav>
                        {this.renderNav()}
                    </nav>
                </header>

                <div className={style.tabContent}>
                    {this.renderTabs()}
                </div>
            </div>
        );
    }

    renderNav() {
        const { children } = this.state;

        return (
            <ul className={classnames(lists.inline, style.list)}>
                {
                    children && children.map((child: React.ReactElement<TabProps>, i: number) => {
                        const buttonClass = i === this.state.index ? style.tabButton : style.inactiveButton;

                        return (
                            <li key={i}>
                                <button className={classnames(buttons.bare, buttonClass)} disabled={child.props.disabled} onClick={this.handleButtonClick.bind(this, i)}>{child.props.title}</button>

                                {child && child.props && child.props.titleBadge && (
                                    <TabBadge background={child.props.titleBadge.background} text={child.props.titleBadge.text} />
                                )}
                            </li>
                        );
                    })
                }
            </ul>
        );
    }

    renderTabs() {
        const { children } = this.state;

        return children && children.map((child: React.ReactElement<TabProps>, i) => {
            const tabClass = i === this.state.index ? style.tab : style.inactiveTab;

            return (
                <div className={tabClass} key={i}>
                    {child}
                </div>
            );
        });
    }

    renderTitle(title: string) {
        if (title) {
            return (
                <div className={style.title}>
                    <h2>{title}</h2>
                </div>
            );
        }
    }
}
